import { type IEmbedWindy } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Windy ({ src }: IEmbedWindy) {
  return (
    <div className={styles.windyEmbed__container}>
      <iframe className={styles.windyEmbed__iframe} loading='lazy' src={src} title='' />
    </div>
  );
}
